module.exports = __webpack_public_path__ + "img/feet.58fd789f.png";